(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            hasContext: hasContext,
            evaluate: evaluate
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;

                if (_identity.context != null) {
                    var storedDomainName = localStorage.getItem("domainName");
                    var thisDomainName = _identity.context.domainName;

                    if (storedDomainName == null || storedDomainName != thisDomainName) {
                        localStorage.clear();
                        localStorage.setItem("domainName", thisDomainName);
                    }
                }

                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function hasContext() {
            if (!_authenticated || !_identity)
                return false;
            return _identity.context !== null && _identity.context !== undefined;
        }

        function checkAuthority(authority) {
            var deferred = $q.defer();
            deferred.resolve(_identity.authorities && _identity.authorities.indexOf(authority) !== -1);
            return deferred.promise;
        }

        function evaluate(expression) {
            var deferred = $q.defer();
            var indexAnd = expression.indexOf("&&");
            var indexOr = expression.indexOf("||");
            if (indexAnd > 0 && (indexAnd < indexOr || indexOr < 0)) {
                var condition = expression.substr(0, indexAnd);
                var exp = expression.substr(indexAnd + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "&&" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else if (indexOr > 0 && (indexAnd > indexOr || indexAnd < 0)) {
                var condition = expression.substr(0, indexOr);
                var exp = expression.substr(indexOr + 2);
                if (condition.indexOf("!") != -1) {
                    condition = condition.substr(1);
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve("!" + result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                } else {
                    checkAuthority(condition)
                        .then(function (result) {
                            evaluate(exp).then(function (res) {
                                deferred.resolve(result.toString() + "||" + res);
                                return deferred.promise;
                            });
                        });
                }
            } else {
                if (expression.indexOf("!") != -1) {
                    expression = expression.substr(1);
                    checkAuthority(expression)
                        .then(function (result) {
                            deferred.resolve("!" + result.toString());
                            return deferred.promise;
                        });
                } else {
                    checkAuthority(expression)
                        .then(function (result) {
                            deferred.resolve(result.toString());
                            return deferred.promise;
                        });
                }
            }
            return deferred.promise;
        }
    }
})();
